import { render } from "./IFSOrderDownload.vue?vue&type=template&id=31ae5faf&scoped=true"
import script from "./IFSOrderDownload.vue?vue&type=script&lang=js"
export * from "./IFSOrderDownload.vue?vue&type=script&lang=js"

import "./IFSOrderDownload.vue?vue&type=style&index=0&id=31ae5faf&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ae5faf"],['__file',"src/components/Orders/OrdersSummary/IFSOrder/IFSOrderDownload.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31ae5faf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31ae5faf', __exports__)) {
    api.reload('31ae5faf', __exports__)
  }
  
  module.hot.accept("./IFSOrderDownload.vue?vue&type=template&id=31ae5faf&scoped=true", () => {
    api.rerender('31ae5faf', render)
  })

}


export default __exports__